import { useEffect } from 'react'
import { withStyles } from '@aura/components/styles'
import Button from '@aura/components/button'
import Form from '@aura/forms/form'
import FormHelperText from '@aura/components/form-helper-text'
import Grid from '@aura/components/grid'
import Box from '@aura/components/box'
import HorizontalGroup from '@aura/components/horizontal-group'
import { useTranslation } from 'react-i18next'
import Link from '@aura/components/link'
import PropTypes from 'prop-types'
import CustomLoader from '../../../../components/custom-loader'
import RegistrationContainerNew from '../../../../components/registration-container-new'
import factorTypes from '../../../../constants/client-servicing-factor-types'
import qrCodeStatuses from '../../../../constants/fetch-qr-code-status'
import { MAGIC_LINK } from '../../../../constants/routes'
import { initialValues } from './constants/form-fields'
import styles from './styles'


const Component = ({
    classes,
    data,
    error,
    factorType,
    initEnrollAuthFactor,
    isBackAllowed,
    onBack,
    onNext,
    onQRCodeCannotScan,
    qrCodeStatus,
    title,
    verbiage
}) => {

    const { t: translate } = useTranslation()
    const isMagicLink = window.location.pathname.includes(MAGIC_LINK)

    useEffect(() => {
        if (factorType) {
            initEnrollAuthFactor({ factorType })
        }

    }, [])

    const handleCannotScan = event => {
        event.preventDefault()
        onQRCodeCannotScan()
    }
    const footerContent = (
        <Grid className={classes.buttonContainer} container item md={12} xs={12}>
            <Grid container className={classes.actionRow} justify="flex-end">
                <HorizontalGroup gutter={10}>
                    {isBackAllowed
                        ? <Button
                            className={classes.buttonSkip}
                            onClick={onBack}
                            variant="text">{translate('back')}
                        </Button>
                        : <></>
                    }
                    <Button
                        className={classes.buttonSubmit}
                        disabled={qrCodeStatus === qrCodeStatuses.PENDING}
                        onClick={onNext}
                        variant="contained">{translate('next')}
                    </Button>
                </HorizontalGroup>
            </Grid>
        </Grid>
    )
    const { href } = data

    return (
        <RegistrationContainerNew {...{ footerActions: footerContent,title: translate(`authenticatorOptions.${title}`), verbiage: translate(`authenticatorOptions.${verbiage}`) }}>
            <Form className={classes.formFlex} {...{
                enableReinitialize: true,
                initialValues: initialValues,
                onSubmit: onNext
            }}>
                <div className={classes.fieldsContainer}>
                    { qrCodeStatus === qrCodeStatuses.PENDING
                        ? <CustomLoader label={translate('loading')} style={{ marginTop: isMagicLink ? '40px' : '0px' }} />
                        : <>
                            <Box className={classes.qrCodeWrapper}>
                                <img alt='qrCode' className={classes.qrCodeImg} src={href}/>
                            </Box>
                            {factorType !== factorTypes.PUSH
                                ? <Link
                                    classes={{ root: classes.link }}
                                    href=""
                                    onClick={handleCannotScan}
                                    underline="none">{translate('cantScan')}
                                </Link>
                                : <></>}
                        </> }
                </div>
                <Box className={classes.warningLine}>{translate('mfaEnrollment.verbiage07')} </Box>
                <div className={classes.contentDivider}></div>
                <FormHelperText className={classes.errorClass} error>{error && translate('oktaApiResponse.' + `${error}`)}</FormHelperText>
            </Form>
        </RegistrationContainerNew>
    )
}

Component.displayName = 'QRCode'

Component.defaultProps = {
    data: {
        href: ''
    }
}

Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        loader: PropTypes.object,
        root: PropTypes.object,
        stepper: PropTypes.object,
        stepperContainer: PropTypes.object
    }),
    data: PropTypes.object,
    error: PropTypes.string,
    initEnrollAuthFactor: PropTypes.func,
    isBackAllowed: PropTypes.bool,
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    onQRCodeCannotScan: PropTypes.func,
    qrCodeStatus: PropTypes.string,
    title: PropTypes.string,
    verbiage: PropTypes.string
}

export default withStyles(Component, styles)
